export const NOT_ACCEPTABLE = 406;
export const UNPROCESSABLE_ENTITY = 422;
export const NOT_FOUND = 404;
export const INTERNAL_ERROR = 500;
export const SERVICE_UNAVAILABLE = 503;
export const BAD_REQUEST = 400;
export const CONFLICT = 409;
export const UNAUTHORIZED = 401;
export const UNDEFINED = 0;
